import { CircleLoader } from "@/components/shared/loaders";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useTenderPermissionsData } from "@/hooks/cache";

import { useTranslation } from "react-i18next";

interface SubmissionOptionComponentProps {
  updateTenderStateMutation: any;
  loading: boolean;
  tenderID: string | undefined;
};

function SubmissionOptionComponent({ updateTenderStateMutation, loading, tenderID }: SubmissionOptionComponentProps) {
  const { t } = useTranslation(["components"]);
  const { canEditDetails } = useTenderPermissionsData(Number(tenderID));

  const handleOnSubmitTender = () => {
    updateTenderStateMutation({
      variables: {
        tenderId: Number(tenderID),
      }
    });
  };

  return (
    <div>
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold">{t("tendersubmission.submit.title")}</CardTitle>
          <CardDescription>{t("tendersubmission.submit.description")}</CardDescription>
        </CardHeader>
        <CardContent>
          <Card className="p-4 bg-red-50 text-red-500 border-red-300">
            {t("tendersubmission.submit.note")}
          </Card>
        </CardContent>
        <CardFooter className="flex justify-end">
          <Button disabled={loading || !canEditDetails} onClick={handleOnSubmitTender} className="gap-2">
            <CircleLoader visible={loading} height={16} width={16} strokeWidth={2} />
            {t("common:buttons.submit")}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}

export default SubmissionOptionComponent;
